/*
 * Get-municipalities.ts
 * Description: Includes function for sending a request
 * to get all municipalities in a province from the API
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';

/**
 * Getting a list of all municipalities in a region
 *
 * @param {String} province - id of a province
 * @return {Object} Promise - a list of all municipalities
 */
export function getMunicipalities(province: string) {
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        Axios({
            url: APIURL + 'municipalities',
            method: 'get',
            params: {
                province,
            },
        }).then((response) => {
            const municipalities = [];
            // Creating a list suitable to be displayed in a select list
            for (const municipality of response.data.data) {
                municipalities.push({
                    value: municipality.id,
                    text: municipality.attributes.name,
                });
            }
            resolve(municipalities);
        }).catch(() => {
            reject();
        });
    });
}
